<!--走进资环/核心价值-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="walkinto" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in coreValueList' :key='item.id'>
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--团队介绍标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--团队介绍-->
      <el-row :span="24" class="box-width carbon background_img">
        <el-col :md="12" :sm="12" :xs="24">
          <div class="team">
            <div v-html="coreTechnologyOne.content" class="htmlImgSize"></div>
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="div_img">
            <el-image class="carbon_img"
                      v-if='coreTechnologyOne.fullPathUrl != null'
                      :src='coreTechnologyOne.fullPathUrl'
            ></el-image>
          </div>
        </el-col>
      </el-row>

      <!--系统平台-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <!--系统平台-->
      <el-carousel indicator-position="outside" style="height: 360px;">
        <el-carousel-item v-for="item in coreTechnologyTwo" :key="item.id" style="height: 360px;">
          <el-row :span="24" class="box-width carbon background_img">
            <el-col :md="12" :sm="12" :xs="24">
              <div class="div_img">
                <el-image class="carbon_img"
                          style="width: 100%;height: 25vw"
                          v-if='item.fullPathUrl != null'
                          :src='item.fullPathUrl'
                ></el-image>
              </div>
            </el-col>
            <el-col :md="12" :sm="12" :xs="24">
              <div class="text" style="margin-top:-20px">
                <h4 style="padding: 0">{{ item.title }}</h4>
                <div v-html="item.content" class="systemSize"></div>
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
      <div class="box-width">
        <!--数据库标题-->
        <div class='title'>
          <div>
            <h1>
              <i class="el-icon-caret-right"></i>{{ cnNameThree }}
            </h1>
            <p>{{ enNameThree }}</p>
          </div>
        </div>
        <!--数据库-->
        <div>
          <div v-html="replaceContent(coreTechnologyThree.content)" class="htmlImgSize"></div>
          <div style="clear:both;"></div>
        </div>
      </div>

        <!--专业模型标题-->
      <div class="box-width">
        <div class='title'>
          <div>
            <h1>
              <i class="el-icon-caret-right"></i>{{ cnNameFour }}
            </h1>
            <p>{{ enNameFour }}</p>
          </div>
        </div>
        <!--专业模型-->
        <div v-html="replaceContent(coreTechnologyFour.content)" class="htmlImgSize"></div>

      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel-item v-for='item in coreValueList' :key='item.id'>
            <el-image
              style="width: 100%;height: 25vw"
              v-if='item.fullPathUrl != null'
              :src='item.fullPathUrl'
            />
          </el-carousel-item>
        </div>

        <!--团队介绍-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--内容-->
            <div class="mpteam" style="text-align: center">
              <el-image
                alt="Image Description"
                style="width:100%"
                v-if='coreTechnologyOne.fullPathUrl != null'
                :src='coreTechnologyOne.fullPathUrl'
              ></el-image>
              <div class="text">
                <div class="team_text" style="text-indent: 2em;">
                  <div v-html="coreTechnologyOne.content" class="htmlImgSize"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--系统平台-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <el-row :gutter="20" class="box-width">
                <el-col :lg="8" :md="12"  :sm="12" :xs="24">
                  <el-card :body-style="{ padding: '0px' }" class="card_box" v-for="item in coreTechnologyTwo" :key="item.id" style="margin-bottom: 10px">
                    <el-image
                      alt="Image Description"
                      if='coreTechnologyOne.fullPathUrl != null'
                      style="width: 100%"
                      :src='item.fullPathUrl'
                      :fit="fit"></el-image>
                    <div class="text" style="padding: 10px">
                      <h4 style="text-align: center;font-size: 16px;font-weight: bold">{{ item.title }}</h4>
                      <div v-html="item.content" class="mpSystemSize"></div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <!--核心价值-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-html="replaceContent(coreTechnologyThree.content)" class="htmlImgSize"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>

        <!--行为指南-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameFour }}
                <span>{{ enNameFour }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-html="replaceContent(coreTechnologyFour.content)" class="htmlImgSize zzo" style="word-wrap: break-word;"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, findCoreTechnologyOne, findCoreTechnologyTwo, findcoreTechnologyThree, findCoreTechnologyFour } from '@api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      enNameOne: '',
      enNameTwo: '',
      cnNameOne: '',
      cnNameTwo: '',
      enNameThree: '',
      cnNameThree: '',
      enNameFour: '',
      cnNameFour: '',
      activeName: 'second',
      fit: 'cover',
      url: require('@assets/images/index/20250409002258.png'),
      src: require('@assets/images/index/caiji.png'),
      userPainPoints: [],
      coreValueList: [],
      coreTechnologyOne: {},
      coreTechnologyTwo: [],
      coreTechnologyThree: {},
      coreTechnologyFour: {},
      carouselParams: {
        type: 1
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.coreValueList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectCoreTechnologyOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectCoreTechnologyTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectCoreTechnologyThre(data[2].id)

        that.enNameFour = data[3].enName
        that.cnNameFour = data[3].cnName
        that.selectCoreTechnologyFour(data[3].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    async selectCoreTechnologyOne (enNameId) {
      let that = this
      await findCoreTechnologyOne(enNameId).then(res => {
        that.coreTechnologyOne = res.data
      })
    },
    async selectCoreTechnologyTwo (enNameId) {
      let that = this
      await findCoreTechnologyTwo(enNameId).then(res => {
        that.coreTechnologyTwo = res.data
      })
    },
    async selectCoreTechnologyThre (enNameId) {
      let that = this
      await findcoreTechnologyThree(enNameId).then(res => {
        that.coreTechnologyThree = res.data
      })
    },
    async selectCoreTechnologyFour (enNameId) {
      let that = this
      await findCoreTechnologyFour(enNameId).then(res => {
        that.coreTechnologyFour = res.data
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    replaceContent (content) {
      return content.replace(/http:\/\/8\.155\.44\.137:9000\/zihuan\//g, 'https://gdlsfw.com/zihuan/');
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}::v-deep .zzo {
   word-wrap: break-word;
}
 .team{
   padding: 20px;
   font-size: 16px;
   text-indent: 2em;
   line-height: 28px
 }
</style>
